import React from 'react';
import PropTypes from 'prop-types';
import PlusIcon from '../../icons/PlusIcon';
import translate from '../../translate';

const AddParticipantBtn = ({ t, onClick, titleKey }) => (
  <div className="add-participant-btn-container">
    <button onClick={onClick} type="button">
      <PlusIcon />
    </button>
    <span>{t(titleKey)}</span>
  </div>
);

AddParticipantBtn.propTypes = {
  t: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  titleKey: PropTypes.string,
};

AddParticipantBtn.defaultProps = {
  titleKey: 'academy.payment.emails.add',
};

export default translate(AddParticipantBtn);
